import { Enum } from './Enum';

export class RPMVendor extends Enum {
  translationKey = 'rpmVendor';

  static asArray: RPMVendor[] = [];

  static byKey: { [name: string]: RPMVendor } = {};

  static readonly SMART_METER = new RPMVendor('SMART_METER');

  static readonly MEDICAL_GUARGIAN = new RPMVendor('MEDICAL_GUARGIAN');

  static toSelectable() {
    return Enum.toSelectable(RPMVendor.asArray);
  }

  constructor(public readonly value: string) {
    super();
    RPMVendor.asArray.push(this);
    RPMVendor.byKey[value] = this;
  }

  get serverValue() {
    if (this === RPMVendor.SMART_METER) return 1;
    if (this === RPMVendor.MEDICAL_GUARGIAN) return 34;
    return undefined;
  }
}

export default RPMVendor;
